import { useEffect as c } from "react";
import { useLatestValue as a } from './use-latest-value.js';
function i(t, e, o, n) {
  var u = a(o);
  c(function () {
    if (!t) return;
    function r(m) {
      u.current(m);
    }
    return document.addEventListener(e, r, n), function () {
      return document.removeEventListener(e, r, n);
    };
  }, [t, e, n]);
}
export { i as useDocumentEvent };